import React from "react";
import { styled } from "@mui/material/styles";
import { tokens as t } from "./tokens";

/* ---------- Card ---------- */
export const Card = styled("div")({
  background: t.color.surface,
  border: `1px solid ${t.color.line}`,
  borderRadius: t.radius.lg,
  boxShadow: t.shadow.sm,
  overflow: "hidden",
});

/* ---------- Toolbar (card дотор хайлт/шүүлтүүр/товчнууд) ---------- */
export const Toolbar = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: 12,
  padding: "16px 18px",
  borderBottom: `1px solid ${t.color.line2}`,
  flexWrap: "wrap",
});

export const Spacer = styled("div")({ flex: 1 });

/* ---------- Stat card ---------- */
const iconTones = {
  brand: { bg: t.color.brandSoft, fg: t.color.brandDark },
  green: { bg: t.color.greenSoft, fg: t.color.green },
  amber: { bg: t.color.amberSoft, fg: t.color.amber },
  slate: { bg: t.color.slateSoft, fg: t.color.slate },
};

const StatRoot = styled(Card)({ padding: "18px 20px", boxShadow: t.shadow.sm });
const StatIcon = styled("div", { shouldForwardProp: (p) => p !== "tone" })(
  ({ tone = "brand" }) => {
    const c = iconTones[tone] || iconTones.brand;
    return {
      width: 40,
      height: 40,
      borderRadius: 11,
      display: "grid",
      placeItems: "center",
      marginBottom: 14,
      background: c.bg,
      color: c.fg,
      "& svg": { width: 21, height: 21 },
    };
  }
);
const StatLabel = styled("div")({ fontSize: 11.5, color: t.color.muted, fontWeight: 600 });
const StatValue = styled("div")({
  fontFamily: t.font.display,
  fontSize: 26,
  fontWeight: 800,
  letterSpacing: "-0.02em",
  marginTop: 3,
  fontVariantNumeric: "tabular-nums",
  "& small": { fontSize: 13, fontWeight: 600, color: t.color.muted },
});

const StatRootCompact = styled(Card)({
  padding: "12px 14px",
  boxShadow: t.shadow.sm,
  display: "flex",
  alignItems: "center",
  gap: 12,
});
const StatIconCompact = styled("div", { shouldForwardProp: (p) => p !== "tone" })(
  ({ tone = "brand" }) => {
    const c = iconTones[tone] || iconTones.brand;
    return {
      width: 36, height: 36, borderRadius: 10, flexShrink: 0,
      display: "grid", placeItems: "center",
      background: c.bg, color: c.fg,
      "& svg": { width: 18, height: 18 },
    };
  }
);
const StatValueCompact = styled("div")({
  fontFamily: t.font.display,
  fontSize: 18,
  fontWeight: 800,
  letterSpacing: "-0.02em",
  marginTop: 1,
  fontVariantNumeric: "tabular-nums",
  "& small": { fontSize: 11, fontWeight: 600, color: t.color.muted },
});

export const StatCard = ({ icon: Icon, tone, label, value, prefix, hint, compact }) => {
  if (compact) {
    return (
      <StatRootCompact>
        {Icon && (
          <StatIconCompact tone={tone}>
            <Icon />
          </StatIconCompact>
        )}
        <div style={{ minWidth: 0 }}>
          <StatLabel>{label}</StatLabel>
          <StatValueCompact>
            {prefix && <small>{prefix} </small>}
            {value}
          </StatValueCompact>
          {hint && (
            <div style={{ fontSize: 10.5, fontWeight: 600, marginTop: 1, color: t.color.muted }}>
              {hint}
            </div>
          )}
        </div>
      </StatRootCompact>
    );
  }
  return (
    <StatRoot>
      {Icon && (
        <StatIcon tone={tone}>
          <Icon />
        </StatIcon>
      )}
      <StatLabel>{label}</StatLabel>
      <StatValue>
        {prefix && <small>{prefix} </small>}
        {value}
      </StatValue>
      {hint && (
        <div style={{ fontSize: 11, fontWeight: 600, marginTop: 8, color: t.color.muted }}>
          {hint}
        </div>
      )}
    </StatRoot>
  );
};

export const StatGrid = styled("div")({
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(210px, 1fr))",
  gap: 16,
  marginBottom: 24,
});

export default Card;
